import { render, staticRenderFns } from "./homeworkItem.vue?vue&type=template&id=76572f94&scoped=true"
import script from "./homeworkItem.vue?vue&type=script&lang=js"
export * from "./homeworkItem.vue?vue&type=script&lang=js"
import style0 from "./homeworkItem.vue?vue&type=style&index=0&id=76572f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76572f94",
  null
  
)

export default component.exports